var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptOuts = function SvgOptOuts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.148 9.953c-.79-1.377-1.172-2.502-1.402-3.642-.34-1.687.439-3.334 1.728-4.385.545-.444 1.17-.293 1.492.286l.728 1.305c.577 1.035.865 1.552.808 2.1-.057.55-.446.996-1.224 1.89zm0 0c1.599 2.789 4.108 5.3 6.9 6.9m0 0c1.377.79 2.502 1.172 3.643 1.402 1.686.34 3.333-.438 4.384-1.728.445-.545.293-1.17-.285-1.492l-1.306-.728c-1.035-.577-1.552-.865-2.1-.808-.549.057-.996.446-1.89 1.224z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m17.5 2.5-5.834 5.833m5.834 0L11.666 2.5"
  })));
};
export default SvgOptOuts;